<div class="card">
  <div class="card-body">
    <div class="mb-26">
      <h4 class="mb-56 d-inline" *ngIf="isAdd">Add Product</h4>
      <h4 class="mb-56 d-inline" *ngIf="!isAdd && edit === 'false'">Product Details</h4>
      <h4 class="mb-56 d-inline" *ngIf="!isAdd && edit !== 'false'">Edit Product</h4>
      <div class="button-row mb-4 d-inline float-end">
        <button *ngIf="!isAdd && edit === 'false'" mat-raised-button class="me-8 mb-8" color="primary" (click)="enableEditMode()">
          <mat-icon class="me-1" style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle;">edit</mat-icon>
          Edit Product
        </button>
        <button *ngIf="isAdd" mat-raised-button class="me-8 mb-8" [routerLink]="['../product']" color="primary">
          Product List
        </button>
        <button *ngIf="!isAdd" mat-raised-button class="me-8 mb-8" [routerLink]="['../../product']" color="primary">
          Product List
        </button>
      </div>
    </div>
    <div class="spinner" *ngIf="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <form [formGroup]="productForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data" #myForm="ngForm"
      [hidden]="spinner">
      <!-- Product Name -->
      <mat-form-field class="w-100 fs-16" appearance="outline">
        <mat-label>Product Name</mat-label>
        <input matInput type="text" formControlName="name" placeholder="Enter product name" />
        <mat-error *ngIf="
            productForm.controls['name'].hasError('required') ||
            myForm.submitted
          ">Name can not be empty.</mat-error>
      </mat-form-field>

      <!-- Warrenty Period In Years -->
      <mat-form-field class="w-100 fs-16" appearance="outline">
        <mat-label>Warrenty Period In Years</mat-label>
        <input matInput type="number" formControlName="warrentyPeriodInYears"
          placeholder="Enter Warrenty Period In Years"/>
        <mat-error *ngIf="
            productForm.controls['warrentyPeriodInYears'].hasError(
              'required'
            ) || myForm.submitted
          ">Warrenty can not be empty.</mat-error>
      </mat-form-field>
      
      <!-- Max Warrenty Period In Months -->
      <mat-form-field class="w-100 fs-16" appearance="outline">
        <mat-label>Max Warranty Period In Months (For Late Registration)</mat-label>
        <input matInput type="number" formControlName="maxWarrentyPeriodInMonths"
          placeholder="Enter Max Warranty Period In Months"/>
        <mat-error *ngIf="
            productForm.get('maxWarrentyPeriodInMonths')?.hasError('required')
          ">Max Warranty can not be empty.</mat-error>
        <mat-error *ngIf="
            productForm.get('maxWarrentyPeriodInMonths')?.hasError('invalidMaxWarranty') && !productForm.get('maxWarrentyPeriodInMonths')?.hasError('required')
          ">Max warranty months must be strictly greater than warranty years in months ({{ getWarrantyMonths() }} months).</mat-error>
      </mat-form-field>

      <!-- Description -->
      <mat-form-field class="w-100 fs-16" appearance="outline">
        <mat-label>Description</mat-label>
        <input matInput type="text" formControlName="description" placeholder="Enter product description"
          maxlength="100" />
        <mat-error *ngIf="
            productForm.controls['description'].hasError('required') ||
            myForm.submitted
          ">Description can not be empty.</mat-error>
      </mat-form-field>

      <!-- Category -->
      <mat-form-field>
        <mat-label>Category</mat-label>
        <input type="text" matInput #categoryInput formControlName="categoryID" [matAutocomplete]="auto" />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option">{{ option.name }}</mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="
            productForm.controls['categoryID'].hasError('required') ||
            myForm.submitted
          ">Category can not be empty.</mat-error>
      </mat-form-field>

      <!-- Image -->
      <!-- <mat-form-field class="w-100 fs-16" appearance="outline">
          <mat-label>Image</mat-label>
          <input
            matInput
            type="text"
            formControlName="image"
            placeholder="Enter image name"
            readonly
          />
        </mat-form-field> -->
      <!-- <input
          #fileInput
          type="file"
          id="file"
          accept="image/*"
          formControlName="image"
          (change)="onFileSelected($event)"
        /> -->

      <button *ngIf="edit !== 'false'" type="button" mat-raised-button (click)="fileInput.click()" class="mb-3">
        Choose File
      </button>
      <input hidden (change)="onFileSelected($event)" #fileInput accept="image/*" multiple="true" type="file" id="file"
        formControlName="image" />
      <br />
      <div>
        <img *ngFor="let preview of preview" [src]="preview" class="preview mb-2" />
      </div>

      <!-- Linked Product Items Section (Visible in BOTH Product Detail and Add/Edit mode when category allows linked products) -->
      <div class="linked-products-panel" *ngIf="isLinkedProductsAllowed()">
        <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
          <div>
            <h5 class="linked-panel-title mb-0 d-flex align-items-center gap-2">
              <mat-icon style="color: #103155; font-size: 20px; width: 20px; height: 20px;">account_tree</mat-icon>
              Linked Product Items
            </h5>
            <div class="linked-panel-subtitle">Components / sub-parts linked to this product with individual warranties</div>
          </div>
          <span class="linked-count-badge">{{ linkedProducts.length }} Item(s) Linked</span>
        </div>

        <!-- Add Item Inputs (Only shown when adding or editing, hidden in Product Detail view) -->
        <div class="row g-2 align-items-center mb-3" *ngIf="edit !== 'false'">
          <!-- Select Category -->
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100 field-compact">
              <mat-label>Category</mat-label>
              <mat-select [(ngModel)]="selectedLinkedCategoryId" [ngModelOptions]="{standalone: true}" (selectionChange)="onLinkedCategoryChange($event.value)">
                <mat-option value="">Select Category</mat-option>
                <mat-option *ngFor="let cat of categories" [value]="cat._id">{{ cat.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Select Product -->
          <div class="col-12 col-md-5">
            <mat-form-field appearance="outline" class="w-100 field-compact">
              <mat-label>Product Item</mat-label>
              <mat-select [(ngModel)]="selectedLinkedProductId" [ngModelOptions]="{standalone: true}" [disabled]="!selectedLinkedCategoryId || isLoadingCategoryProducts">
                <mat-option value="">Select Product</mat-option>
                <mat-option *ngFor="let p of categoryProductsForLinking" [value]="p._id">
                  {{ p.name }} ({{ p.warrentyPeriodInYears || 0 }} Yrs / {{ p.maxWarrentyPeriodInMonths || 0 }} Mo Max)
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Add Button -->
          <div class="col-12 col-md-3">
            <button
              type="button"
              mat-raised-button
              color="primary"
              class="w-100 btn-add-item"
              (click)="addLinkedProduct()"
              [disabled]="!selectedLinkedProductId">
              <mat-icon class="me-1" style="font-size: 18px; width: 18px; height: 18px;">add</mat-icon>
              Add Item
            </button>
          </div>
        </div>

        <!-- Table of Linked Products (Shown in BOTH Product Detail and Edit mode) -->
        <div class="table-responsive" *ngIf="linkedProducts.length > 0">
          <table class="linked-items-table">
            <thead>
              <tr>
                <th style="width: 45px;">#</th>
                <th>Category</th>
                <th>Product Item Name</th>
                <th class="text-center" style="width: 150px;">Warranty</th>
                <th class="text-center" style="width: 170px;">Max Warranty</th>
                <th class="text-center" style="width: 70px;" *ngIf="edit !== 'false'">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of linkedProducts; let i = index">
                <td>{{ i + 1 }}</td>
                <td class="item-category">{{ item.categoryName }}</td>
                <td class="item-name">{{ item.name }}</td>
                <td class="text-center item-warranty">{{ item.warrentyPeriodInYears }} Year(s)</td>
                <td class="text-center item-warranty">{{ item.maxWarrentyPeriodInMonths }} Month(s)</td>
                <td class="text-center" *ngIf="edit !== 'false'">
                  <button type="button" mat-icon-button (click)="removeLinkedProduct(i)" matTooltip="Remove Item" style="color: #64748b;">
                    <mat-icon style="font-size: 18px; width: 18px; height: 18px;">delete_outline</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Empty State -->
        <div class="linked-empty-state" *ngIf="linkedProducts.length === 0">
          <span>No product items linked to this product.</span>
        </div>
      </div>

      <div *ngIf="edit === 'false'">
        <hr class="my-4" />

        <div class="assign-section-panel">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-3 assign-header-row">
            <div>
              <h5 class="assign-panel-title mb-1">Assign Barcodes / QR Codes to Product</h5>
              <div class="assign-panel-subtitle">Select range or scan using handheld scanner. Batch is detected automatically.</div>
            </div>

            <!-- Mode Selector: Code Range Mode is 1st and Default -->
            <div class="mode-switch-container" role="group">
              <button
                type="button"
                class="mode-switch-btn"
                [class.active]="assignMode === 'range'"
                (click)="setAssignMode('range')">
                <mat-icon class="mode-icon">format_list_numbered</mat-icon>
                <span>Code Range Mode</span>
              </button>
              <button
                type="button"
                class="mode-switch-btn"
                [class.active]="assignMode === 'scan'"
                (click)="setAssignMode('scan')">
                <mat-icon class="mode-icon">qr_code_scanner</mat-icon>
                <span>Scanner / Textarea Mode</span>
              </button>
            </div>
          </div>

          <form #myForm2="ngForm" [formGroup]="batchForm" (ngSubmit)="batchAdd()">

            <!-- OPTION 1: CODE RANGE MODE (1st and Default) -->
            <div *ngIf="assignMode === 'range'" class="row g-3 align-items-start input-row-spacing">
              <!-- Start Code -->
              <div class="col-12 col-md-4">
                <mat-form-field class="w-100 field-no-subscript" appearance="outline">
                  <mat-label>Start Barcode / QR Code</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="startCode"
                    placeholder="Enter or scan start code"
                    id="start-code-input" />
                </mat-form-field>
              </div>

              <!-- End Code -->
              <div class="col-12 col-md-4">
                <mat-form-field class="w-100 field-no-subscript" appearance="outline">
                  <mat-label>End Barcode / QR Code</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="endCode"
                    placeholder="Enter or scan end code"
                    id="end-code-input" />
                </mat-form-field>
              </div>

              <!-- Manufacture Date -->
              <div class="col-12 col-md-2">
                <mat-form-field class="w-100 field-no-subscript" appearance="outline">
                  <mat-label>Manufacture Date</mat-label>
                  <input
                    matInput
                    [matDatepicker]="mfgPickerRange"
                    placeholder="Select Date"
                    formControlName="registerDate" />
                    <mat-datepicker-toggle matIconSuffix [for]="mfgPickerRange"></mat-datepicker-toggle>
                    <mat-datepicker #mfgPickerRange></mat-datepicker>
                </mat-form-field>
              </div>

              <!-- Assign Button (Exact 56px height to match outline inputs) -->
              <div class="col-12 col-md-2">
                <button
                  mat-raised-button
                  type="button"
                  class="btn-assign-action w-100"
                  [disabled]="isAdding"
                  (click)="batchAdd()">
                  <span *ngIf="!isAdding">Assign Range</span>
                  <mat-spinner
                    *ngIf="isAdding"
                    diameter="20"
                    style="display:inline-block; vertical-align:middle; margin-left:8px;">
                  </mat-spinner>
                </button>
              </div>
            </div>

            <!-- OPTION 2: SCANNER TEXTAREA MODE -->
            <div *ngIf="assignMode === 'scan'" class="row g-3 align-items-start input-row-spacing">
              <div class="col-12 col-lg-8">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <label class="form-label fw-semibold fs-14 mb-0 text-dark">
                    <mat-icon class="align-middle fs-16 me-1" style="color: #103155; vertical-align: middle;">document_scanner</mat-icon>
                    Scan Barcodes / QR Codes:
                  </label>
                  <div class="d-flex align-items-center gap-2">
                    <span class="scan-counter-badge">
                      {{ getScannedCodeCount() }} code(s) detected
                    </span>
                    <button
                      *ngIf="getScannedCodeCount() > 0"
                      type="button"
                      mat-button
                      color="warn"
                      class="btn-sm p-0 fs-12"
                      style="min-width: unset; line-height: 1;"
                      (click)="clearScannedCodes()">
                      Clear
                    </button>
                  </div>
                </div>

                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Click / Focus here to scan with handheld scanner</mat-label>
                  <textarea matInput formControlName="scannedCodes" rows="5"
                    placeholder="Focus here and scan codes with your handheld scanner (each scan adds code on a new line)..."
                    class="scanner-input-textarea" id="scanner-textarea">
                  </textarea>
                  <mat-hint class="fs-12 text-muted">
                    Focus here and scan items one by one. Accepts barcodes or QR codes (separated by newlines or
                    commas).
                  </mat-hint>
                </mat-form-field>
              </div>

              <!-- Manufacture Date & Submit -->
              <div class="col-12 col-lg-4">
                <div class="mb-3">
                  <mat-form-field class="w-100 field-no-subscript" appearance="outline">
                    <mat-label>Manufacture Date</mat-label>
                    <input matInput [matDatepicker]="mfgPickerScan" placeholder="Select Manufacture Date" formControlName="registerDate" />
                    <mat-datepicker-toggle matIconSuffix [for]="mfgPickerScan"></mat-datepicker-toggle>
                    <mat-datepicker #mfgPickerScan></mat-datepicker>
                  </mat-form-field>
                </div>

                <div>
                  <button
                    mat-raised-button
                    type="button"
                    class="btn-assign-action w-100 fs-15"
                    [disabled]="isAdding || getScannedCodeCount() === 0"
                    (click)="batchAdd()">
                    <span *ngIf="!isAdding">
                      <mat-icon class="me-1" style="height:18px;width:18px;font-size:18px;line-height:18px;vertical-align:middle;">save</mat-icon>
                      Assign Scanned ({{ getScannedCodeCount() }})
                    </span>
                    <mat-spinner
                      *ngIf="isAdding"
                      diameter="20"
                      style="display:inline-block; vertical-align:middle; margin-left:8px;">
                    </mat-spinner>
                  </button>
                </div>
              </div>
            </div>

          </form>
        </div>

        <!-- OLD FUNCTIONALITY: DIRECT ADD BATCH & INSTANT QR CODE GENERATION -->
        <div class="assign-section-panel mt-4">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 assign-header-row mb-3">
            <div>
              <h5 class="assign-panel-title mb-1">
                <mat-icon class="align-middle me-1" style="vertical-align: middle; color: #103155;">qr_code_2</mat-icon>
                Add Batch (Direct QR Code Generation)
              </h5>
              <div class="assign-panel-subtitle">Create a batch directly for this product with auto-generated QR codes and download printable PDF stickers.</div>
            </div>
          </div>

          <form #oldBatchNgForm="ngForm" [formGroup]="oldBatchForm" (ngSubmit)="oldBatchAdd()">
            <div class="row g-3 align-items-start input-row-spacing">
              <!-- Quantity -->
              <div class="col-12 col-md-5">
                <mat-form-field class="w-100 field-no-subscript" appearance="outline">
                  <mat-label>Total Quantity</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="quantity"
                    placeholder="Enter Total Quantity (e.g. 50)"
                    min="1" />
                  <mat-error *ngIf="oldBatchForm.controls['quantity'].hasError('required') || oldBatchNgForm.submitted">
                    Quantity is required.
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Manufacture Date -->
              <div class="col-12 col-md-4">
                <mat-form-field class="w-100 field-no-subscript" appearance="outline">
                  <mat-label>Manufacture Date</mat-label>
                  <input
                    matInput
                    [matDatepicker]="oldMfgPicker"
                    placeholder="Select Manufacture Date"
                    formControlName="registerDate" />
                  <mat-datepicker-toggle matIconSuffix [for]="oldMfgPicker"></mat-datepicker-toggle>
                  <mat-datepicker #oldMfgPicker></mat-datepicker>
                  <mat-error *ngIf="oldBatchForm.controls['registerDate'].hasError('required') || oldBatchNgForm.submitted">
                    Manufacture Date is required.
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Add Batch Button -->
              <div class="col-12 col-md-3">
                <button
                  mat-raised-button
                  color="primary"
                  type="button"
                  class="btn-assign-action w-100"
                  [disabled]="isAdding"
                  (click)="oldBatchAdd()">
                  <span *ngIf="!isGeneratingOldBatch">
                    <mat-icon class="me-1 align-middle" style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle;">add_circle</mat-icon>
                    Add Batch
                  </span>
                  <mat-spinner
                    *ngIf="isGeneratingOldBatch"
                    diameter="20"
                    style="display:inline-block; vertical-align:middle; margin-left:8px;">
                  </mat-spinner>
                </button>
              </div>
            </div>

            <!-- QR Code elements for PDF canvas rendering -->
            <div *ngFor="let qrCode of myAngularxQrCode" class="d-inline-grid" style="position: fixed; left: -9999px; top: 0; opacity: 0; pointer-events: none;">
              <qr-code [id]="qrCode" [value]="qrCode" size="20" errorCorrectionLevel="L"></qr-code>
            </div>

            <!-- Download Alert when QR Codes are ready -->
            <div *ngIf="myAngularxQrCode && myAngularxQrCode.length > 0" class="mt-3 p-3 bg-light rounded d-flex align-items-center justify-content-between flex-wrap gap-2">
              <span class="text-success fw-semibold">
                <mat-icon class="align-middle me-1 text-success" style="vertical-align: middle;">check_circle</mat-icon>
                {{ myAngularxQrCode.length }} QR codes generated successfully for this batch!
              </span>
              <a
                (click)="download()"
                mat-raised-button
                download="qrcode"
                [disabled]="isAdding">
                Download
              </a>
            </div>
          </form>
        </div>
      </div>

      <!-- <button *ngIf="isAdd" [disabled]="productForm.errors || productForm.invalid || isSubmitting" mat-raised-button
        color="primary" type="submit">
        Submit
      </button> -->

      <button *ngIf="isAdd" [disabled]="productForm.invalid || isSubmitting || isAdding"mat-raised-button
        color="primary" type="submit">
        <span *ngIf="!isAdding">Submit</span>

        <mat-spinner
          *ngIf="isAdding"
          diameter="20"
          class="d-inline-block ms-2">
        </mat-spinner>

      </button>

      <!-- Action Buttons on Edit Product view (Submit & Cancel) -->
      <div *ngIf="!isAdd && edit !== 'false'" class="d-inline-flex align-items-center gap-2">
        <button [disabled]="productForm.invalid || isSubmitting" mat-raised-button color="primary" type="button" (click)="onEdit()">
          <span *ngIf="!isSubmitting">Submit</span>
          <mat-spinner
            *ngIf="isSubmitting"
            diameter="20"
            class="d-inline-block ms-2">
          </mat-spinner>
        </button>
        <button mat-stroked-button type="button" (click)="onCancelEdit()" [disabled]="isSubmitting">
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>